import React from 'react'

interface KeyProps {
  size?: number
  color?: string
}

export const Key: React.FC<KeyProps> = ({
  size = 24,
  color = 'currentColor',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.426 11.143H11.91C11.483 8.7 9.383 6.857 6.854 6.857 4.027 6.857 1.71 9.172 1.71 12c0 2.829 2.315 5.143 5.143 5.143 2.529 0 4.672-1.843 5.057-4.286h5.229v3.429h1.714v-3.43h1.715v3.43h1.714V12a.86.86 0 00-.857-.857zM6.854 15.43A3.439 3.439 0 013.427 12a3.439 3.439 0 013.428-3.428A3.439 3.439 0 0110.283 12a3.439 3.439 0 01-3.43 3.43z"
        fill={color}
      />
    </svg>
  )
}
